import {getUrlParameter} from 'libs/url.js';
import {cookieStore, localStore} from 'libs/storage/storage';
import {AFF_ID} from 'constants/store';

/**
 * Migrates affiliate ID from local storage to cookie storage.
 * Since AFF_ID data is required for properly server-side rendering(CMS banners), the function safely moves AFF_ID from store to store
 * to save marketing programs for customers that already have stored an affiliate ID.
 * @param {string} affIdFromLocalStorage - affiliate ID stored in localStorage
 */
export const migrateAffiliateIdStorages = (affIdFromLocalStorage: string) => {
    cookieStore.set(AFF_ID, affIdFromLocalStorage);
    localStore.remove(AFF_ID);
};

/**
 * Get actual affiliate id.
 *
 * Affiliates have a priority, where:
 * URL - high (https://glassesusa.com?affid=AFFILIATE_ID)
 * localStorage - low (gusa_aff_id)
 *
 * @param {string} [url] - affiliate ID stored in localStorage
 * @param {object} [cookies] - cookies data passed during server side rendering
 * @return {string} affiliate id
 */
export const getAffId = (url?: string, cookies = {}): string => {
    const affIdFromUrl = getUrlParameter('affid', url);
    const affIdFromLocalStorage = localStore.get(AFF_ID);

    if (affIdFromLocalStorage) {
        migrateAffiliateIdStorages(affIdFromLocalStorage);
    }

    const affIdFromCookieStorage = cookies[AFF_ID] || cookieStore.get(AFF_ID);

    return affIdFromUrl || affIdFromCookieStorage || '';
};
